var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckBox, CheckBoxOutlineBlank, CheckCircle, IndeterminateCheckBox, RadioButtonChecked, RadioButtonUnchecked, } from '@mui/icons-material';
import { Checkbox as MUICheckbox } from '@mui/material';
const Checkbox = (_a) => {
    var { checkedIcon, icon, indeterminateIcon, shape = 'square', undetermined = false } = _a, props = __rest(_a, ["checkedIcon", "icon", "indeterminateIcon", "shape", "undetermined"]);
    const iconChecked = shape === 'square' ? checkedIcon || _jsx(CheckBox, {}) : _jsx(CheckCircle, {});
    const iconDefault = shape === 'square' ? icon || _jsx(CheckBoxOutlineBlank, {}) : _jsx(RadioButtonUnchecked, {});
    const iconIndeterminate = shape === 'square' ? indeterminateIcon || _jsx(IndeterminateCheckBox, {}) : _jsx(RadioButtonChecked, {});
    return (_jsx(MUICheckbox, Object.assign({ sx: {
            padding: 0.5,
        } }, props, { icon: iconDefault, checkedIcon: iconChecked, indeterminate: undetermined, indeterminateIcon: iconIndeterminate })));
};
export default Checkbox;
